import { __decorate, __extends } from "tslib";
import { Message } from "../../Message.mjs";
import { MessageParamDefinition, MessageType } from "../../MessageDefinition.mjs";
var Reply341Inviting = /** @class */ (function (_super) {
    __extends(Reply341Inviting, _super);
    function Reply341Inviting() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        MessageParamDefinition({})
    ], Reply341Inviting.prototype, "me", void 0);
    __decorate([
        MessageParamDefinition({})
    ], Reply341Inviting.prototype, "nick", void 0);
    __decorate([
        MessageParamDefinition({
            type: 'channel'
        })
    ], Reply341Inviting.prototype, "channel", void 0);
    Reply341Inviting = __decorate([
        MessageType('341')
    ], Reply341Inviting);
    return Reply341Inviting;
}(Message));
export { Reply341Inviting };
